export const isNewYearPeriod = () => {
  const date = new Date();
  const month = date.getMonth();

  // INFO: С 1 декабря по 31 января у нас Новый год
  if (month === 11 || month === 0) {
    return true;
  }

  return false;
};
